import Box from '@mui/material/Box'
import Tab from '@mui/material/Tab'
import { ReactNode, useEffect, useState } from 'react'

import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'

export type MoovyTabProps = {
  defaultPanel?: string
  tabKey: string
  tabHeaders: string[]
  tabPanels: ReactNode[]
}

const MoovyTab = ({
  tabKey,
  tabHeaders,
  defaultPanel,
  tabPanels,
}: MoovyTabProps) => {
  const ssKey = `MoovyTab${tabKey}CurrentTab`
  const valueFromStorage = sessionStorage.getItem(ssKey)
  const [currentTab, setCurrentTab] = useState(
    valueFromStorage || defaultPanel || '0',
  )

  useEffect(() => {
    if (Number.parseInt(currentTab) >= tabPanels.length) {
      setCurrentTab((tabPanels.length - 1).toString())
    }
  }, [currentTab])

  const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
    sessionStorage.setItem(ssKey, newValue)
    setCurrentTab(newValue)
  }

  return (
    <TabContext value={currentTab}>
      <Box sx={{ paddingTop: 2, borderBottom: 1, borderColor: 'divider' }}>
        <TabList onChange={handleChange}>
          {tabHeaders.map((header, index) => (
            <Tab label={header} key={index} value={index.toString()} />
          ))}
        </TabList>
      </Box>
      {tabPanels.map((item, index) => (
        <TabPanel key={index} value={index.toString()} style={{ padding: 0 }}>
          {item}
        </TabPanel>
      ))}
    </TabContext>
  )
}

export default MoovyTab
